import Language from '../../../language/language';

export const resetPasswordSendStart = () => {
    return {
        type : "RESET_PASSWORD_SEND_START"
    }
}
export const resetPasswordSendSuccess = () => {
    return {
        type : "RESET_PASSWORD_SEND_SUCCESS"
    }
}
export const resetPasswordSendFail = (message) => {
    return {
        type : "RESET_PASSWORD_SEND_FAIL",
        payload : {
            message
        }
    }
}

export const sendPasswordResetEmail = (email) => {
    return (dispatch, getState, getFirebase) => {
        dispatch(resetPasswordSendStart());
        const firebase = getFirebase();
        const auth = firebase.auth();
        const {language} = getState().universal;
        auth.languageCode = language;
        // var actionCodeSettings = {
        //     url: 'https://www.example.com/?email=user@example.com',
        //     iOS: {
        //       bundleId: 'com.example.ios'
        //     },
        //     android: {
        //       packageName: 'com.example.android',
        //       installApp: true,
        //       minimumVersion: '12'
        //     },
        //     handleCodeInApp: true
        //   };
        auth.sendPasswordResetEmail(email)
            .then(() => {
                dispatch(resetPasswordSendSuccess())
            })
            .catch((e) => {
                let message = '';
                switch(e.code) {
                    case 'auth/invalid-email' : {
                        message = Language.resetPassword.fail.invalidEmail[language];
                    }break;
                    case 'auth/user-not-found' : {
                        message = Language.resetPassword.fail.userNotFound[language];
                    }break;
                    // case 'auth/missing-android-pkg-name' : {
                    // }break;
                    // case 'auth/missing-continue-uri' : {
                    // }break;
                    // case 'auth/missing-ios-bundle-id' : {
                    // }break;
                    // case 'auth/invalid-continue-uri' : {
                    // }break;
                    // case 'auth/unauthorized-continue-uri' : {
                    // }break;
                    default : {}break;
                }
                dispatch(resetPasswordSendFail(message));
            })
    }
}


// WEBPACK FOOTER //
// ./src/components/ResetPassword/actions/resetActions.js